import { render } from "./Progressbar.vue?vue&type=template&id=22dd65c5&scoped=true&ts=true"
import script from "./Progressbar.vue?vue&type=script&lang=ts"
export * from "./Progressbar.vue?vue&type=script&lang=ts"

import "./Progressbar.vue?vue&type=style&index=0&id=22dd65c5&scoped=true&lang=scss"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22dd65c5"]])

export default __exports__